import { useEffect, useState } from "react";
import swal from "sweetalert";
import dayjs from "dayjs";

import { Button } from "../../elements/Button";
import buttoncss from "../../css/button.module.css";
import icrCss from "../../css/interCompanyEliminations.module.css";
import commoncss from "../../css/common.module.css";
import { ReactComponent as CalendarIcon } from "../../assets/icons/Calendar.svg";
import { ReactComponent as EditIcon } from "../../assets/icons/edit.svg";
import { getAllConsolAutoAdjustmentsApiHandler } from "../../../WorkSpace/Components/ApiServices/apiHandler";
import CreateEditEntryModal from "./CreateEditEntryModal";
import Breadcrumb from "../Breadcrumb";

const AdjAutoPopulatedEntries = ({ history, consolID, workspaceName, consolName, workspaceID }) => {
  const [autoAdjustments, setAutoAdjustments] = useState([]);
  const [autoAdjustmentID, setAutoAdjustmentID] = useState(null);
  const [entryModal, setEntryModal] = useState(false);
  const [selectedEntry, setSelectedEntry] = useState(null);

  const closeEntryModal = () => {
    setEntryModal(false);
    setSelectedEntry(null);
  };

  useEffect(() => {
    getAutoAdjustments();
  }, []);

const getAutoAdjustments = (cat) => {
    const getParams = {
      category: cat,
      consolID: consolID,
    };
    console.log("consolID being sent to getAutoAdjustments:", consolID); // ADD THIS
    console.log("getParams:", getParams);                                  // ADD THIS
    getAllConsolAutoAdjustmentsApiHandler(getParams)
    getAllConsolAutoAdjustmentsApiHandler(getParams)
      .then((response) => {
        if (response?.data?.success === true) {
          const autoAdjData = response?.data;
          console.log("FULL API RESPONSE:", autoAdjData);
          console.log("autoAdjustments array:", autoAdjData?.autoAdjustments);
          console.log("autoAdjustmentID:", autoAdjData?.autoAdjustmentID);
          console.log("First item:", autoAdjData?.autoAdjustments?.[0]);
          console.log("First item _id:", autoAdjData?.autoAdjustments?.[0]?._id);
          console.log("First item autoAdjustmentID:", autoAdjData?.autoAdjustments?.[0]?.autoAdjustmentID);
          setAutoAdjustments(autoAdjData?.autoAdjustments ?? []);
          setAutoAdjustmentID(autoAdjData?.autoAdjustmentID ?? null);
        } else {
          setAutoAdjustments([]);
          setAutoAdjustmentID(null);
          swal(
            "Error",
            response?.data?.error || "Unable to get auto adjustments",
            "error"
          );
        }
      })
      .catch((error) => {
        setAutoAdjustments([]);
        setAutoAdjustmentID(null);
        swal(
          "Error",
          error?.response?.data?.error || "Unable to populate auto adjustments",
          "error"
        );
      });
  };

  return (
    <>
      <div
        className={icrCss.header}
        style={{ justifyContent: "space-between", gap: "10px", padding: "10px 0px 0px 0px" }}
      >
        <div style={{ display: "flex", alignItems: "center" }}>
          <Breadcrumb
            addCls="bgTransprent"
            p0={true}
            items={[
              { label: workspaceName || "Workspace", link: workspaceID ? `/consolidation/${workspaceID}` : `/myfinV2/standalonefs`, className: "nav_cnt_color clickable" },
              { label: `${consolName || "Consol"} - Adjustments - Auto populated entries`, link: "", className: "headerLable" },
            ]}
            backLink={workspaceID ? `/consolidation/${workspaceID}` : "/myfinV2/standalonefs"}
          />
        </div>
        <Button
          btnColor={buttoncss.primary}
          label="Populate FS"
          onClick={() => {
            history.push(`/myfinV2/console-populatefs/${consolID}`);
          }}
        />
      </div>
      <div className={icrCss.entrytableCtn} style={{paddingTop: "10px", paddingLeft: "0px", paddingRight: "0px"}}>
        {autoAdjustments && autoAdjustments.length > 0 && 
          autoAdjustments.map((item, index) => (
            <div>
              <table className={`${icrCss.entrytable} mt-1 mb-3`}>
                <thead>
                  <tr>
                    <th style={{ textAlign: "left", paddingLeft: "20px" }}>Particulars</th>
                    <th className="text-right" style={{ width: "200px" }}>
                      Current year
                    </th>
                    <th className="text-right" style={{ width: "200px", paddingRight: "30px" , whiteSpace: "noWrap"}}>
                      Previous year
                    </th>
                    <th className="text-center" style={{ width: "55px" }}></th>
                  </tr>
                </thead>
                <tbody>
                  {item?.adjustments &&
                    item?.adjustments.map((adj, adj_index) => (
                      <tr key={`${index}-${adj_index}`}>
                        <td style={{ textAlign: "left",  paddingLeft: "20px" }}>{adj.levelThree}</td>
                        <td className="text-right">
                          {adj.currentYear !== null && adj.currentYear !== undefined
                            ? (() => {
                                const num = Math.round(Number(adj.currentYear));
                                if (isNaN(num)) return "";
                                return num < 0
                                  ? `(${Math.abs(num).toLocaleString("en-IN")})`
                                  : num.toLocaleString("en-IN");
                              })()
                            : ""}
                        </td>

                        <td className="text-right" style={{ paddingRight: "30px" }}>
                          {adj.previousYear !== null && adj.previousYear !== undefined
                            ? (() => {
                                const num = Math.round(Number(adj.previousYear));
                                if (isNaN(num)) return "";
                                return num < 0
                                  ? `(${Math.abs(num).toLocaleString("en-IN")})`
                                  : num.toLocaleString("en-IN");
                              })()
                            : ""}
                        </td>

                        {adj_index === 0 && (
                          <td
                            rowSpan={item.adjustments.length}
                            className="text-center"
                            style={{ paddingRight: "17px" }}
                          >
                            <EditIcon
                              height={18}
                              width={18}
                              style={{ cursor: "pointer" }}
                              onClick={() => {
                                setSelectedEntry(item);
                                setEntryModal(true);
                              }}
                            />
                          </td>
                        )}
                      </tr>
                    ))}
                  <tr>
                    <td
                      colSpan={2}
                      className="text-left"
                      style={{
                        borderTop: "1px solid #EAEEED",
                        padding: "15px 20px",
                        paddingRight: "0px",
                      }}
                    >
                      {item.remarks && (
                        <div className={commoncss.headingColor}>
                          <strong >Remarks <span style={{ marginRight: "4px" }}></span></strong> {item.remarks}
                        </div>
                      )}
                    </td>
                    <td style={{ borderTop: "1px solid #EAEEED", backgroundColor: "#ffffff"}} colSpan={2}></td>
                    {/* <td
                      style={{
                        "border-top": "1px solid #EAEEED",
                        "padding": "10px 0 10px 30px",
                      }}
                    >
                      {item.adjustmentDate && (
                        <span className={commoncss.tag3}>
                          {dayjs(item.adjustmentDate).format("DD-MMM-YYYY")}{" "}
                          <CalendarIcon
                            height={17}
                            style={{ marginLeft: "3px", verticalAlign: "sub" }}
                          />
                        </span>
                      )}
                    </td> */}
                  </tr>
                </tbody>
              </table>
            </div>
          ))}
        {autoAdjustments.length === 0 && (
          <table className={icrCss.entrytable}>
            <thead>
              <tr>
                <th className="text-left">Particulars</th>
                <th className="text-right">Current year</th>
                <th className="text-right">Previous year</th>
              </tr>
            </thead>

            <tbody>
              <tr>
                <td colSpan={3}>No Adjustment Data</td>
              </tr>
            </tbody>
          </table>
        )}
      </div>
      {entryModal && (
        <CreateEditEntryModal
          consolID={consolID}
          handleClose={closeEntryModal}
          editData={
            selectedEntry
              ? {
                  ...selectedEntry,
                  _id: selectedEntry.autoAdjustmentID || selectedEntry._id,
                  autoAdjustmentID: selectedEntry.autoAdjustmentID || selectedEntry._id,
                }
              : null
          }
          getManualAdjustments={getAutoAdjustments}
          type="auto"
        />
      )}
    </>
  );
};

export default AdjAutoPopulatedEntries;
